/* istanbul ignore file */
import React from 'react';
import { TRACKING } from 'common/constants/constants';
import velocityMetricsCTA from 'images/velocityMetricsCTA.svg';
import CtaPage from 'components/CtaPage';
import { TEXT_POSITION } from 'components/CtaPage/constants';

const SECTION_TYPES = {
  VELOCITY: 'VELOCITY',
  TABLE: 'TABLE'
};

const TEXTS = {
  [SECTION_TYPES.VELOCITY]:
    'Get iteration-based visibility into what your teams' +
    ' worked on and what they were able to deliver. Use this' +
    ' data to optimize future project scoping and adjust resourcing as needed',
  [SECTION_TYPES.TABLE]:
    'Use this more granular view of iteration velocity' +
    ' to see what a team or the whole organization worked' +
    ' on–presented as a discrete issue count or as a percentage of total work.'
};

const VelocityCta = () => (
  <CtaPage
    data-testid='freeLicenseCTA'
    textsMap={TEXTS}
    page={TRACKING.PAGES.METRICS}
    pageTab={TRACKING.PAGE_TABS.ISSUES_VELOCITY}
    buttonLineProps={{
      textWidth: '70%',
      leftText: 'Unlock velocity dashboard to see!'.toUpperCase(),
      buttonText: 'BOOK A DEMO NOW'
    }}
    backgroundImage={velocityMetricsCTA}
    sections={[
      {
        sectionType: SECTION_TYPES.VELOCITY,
        buttonPosition: {
          left: '43%',
          top: '14rem'
        },
        coverProps: {
          height: '30rem',
          width: '100%'
        },
        textPosition: {
          left: TEXT_POSITION,
          top: '14rem'
        },
        isTextLeft: true
      },
      {
        sectionType: SECTION_TYPES.TABLE,
        buttonPosition: {
          left: '35%',
          top: '40rem'
        },
        coverProps: {
          height: '20rem',
          width: '100%',
          position: { right: 0, top: '30rem' }
        },
        textPosition: {
          right: TEXT_POSITION,
          top: '35rem'
        }
      }
    ]}
  />
);

export default VelocityCta;
